module.exports = __webpack_public_path__ + "7049acb0cb69a64c06bd37bd2f5ffe34.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Light.woff
// module id = 405
// module chunks = 0